/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Start_2_DescInputs */

const en_mk_start_2_desc = /** @type {(inputs: Mk_Start_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every division you tick immediately gets a chat channel and one agent with instructions that make sense for that role. All of it is editable later.`)
};

const id_mk_start_2_desc = /** @type {(inputs: Mk_Start_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiap divisi yang Anda centang langsung mendapat channel obrolan dan satu agen dengan instruksi kerja yang masuk akal untuk peran itu. Semuanya bisa Anda ubah nanti.`)
};

/**
* | output |
* | --- |
* | "Every division you tick immediately gets a chat channel and one agent with instructions that make sense for that role. All of it is editable later." |
*
* @param {Mk_Start_2_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_start_2_desc = /** @type {((inputs?: Mk_Start_2_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Start_2_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_start_2_desc(inputs)
	return en_mk_start_2_desc(inputs)
});